import { Controller } from "@hotwired/stimulus"
import { Loggable } from "./concerns/loggable"
import { ShowHide } from "./concerns/showHide";

export default class extends Controller {

  static targets = [ "entry" ]

  initialize(){
    Loggable(this, {debug: true})
    ShowHide(this)
    this.log("initialized")
  }
  connect(){
    this.log("conected")
  }

  updateFilter(event){
    let target = event.target
    let showType = target.dataset.option
    this.entryTargets.forEach((e) => {
      if ( e.classList.contains(showType) ) {
        this.show(e)
      } else {
        this.hide(e)
      }
    })
  }
}
